export default __webpack_public_path__ + "static/media/sync.66583c9a.svg";